// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2-Osw","errorLogs":"styles_errorLogs__3wkbW"};